import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwo-software-integrations',
  templateUrl: './hometwo-software-integrations.component.html',
  styleUrls: ['./hometwo-software-integrations.component.scss']
})
export class HometwoSoftwareIntegrationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
